// apis
import { TextAPI } from '../apis/text.api';

// libraries
import { atom, selector } from 'recoil';

/** 이용약관 텍스트 */
export const TermsAtom = selector<string>({
  key: 'TermsAtom',
  get: async () => {
    return await new TextAPI().getTerms();
  }
});

/** 개인정보처리방침 텍스트 */
export const PrivacyAtom = selector<string>({
  key: 'PrivacyAtom',
  get: async () => {
    return await new TextAPI().getPrivacy();
  }
});

/** 이용약관 모달 */
export const TermsModalAtom = atom<boolean>({
  key: 'TermsModalAtom',
  default: false
});

/** 개인정보처리방침 모달 */
export const PrivacyModalAtom = atom<boolean>({
  key: 'PrivacyModalAtom',
  default: false
});
